import React, {ReactNode, ReactNodeArray, useEffect} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadTicketData from '../../../Models/Content/AbroadTicketBlockData';
import AbroadTicketMain from '../AbroadTicketBlock/AbroadTicketMain';
export default class AbroadTicket extends EpiComponent<AbroadTicketData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    const context = this.getContext();
    const iContent = this.props.data;

    return <AbroadTicketMain context={context} iContent={iContent}></AbroadTicketMain>;
  }
}
